import { c as _c } from "react/compiler-runtime";
import { IcoInfo16 } from '@onefootprint/icons';
import { Badge, Tag, Tooltip } from '@onefootprint/ui';
import isNull from 'lodash/isNull';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { FormattedPerson } from '../../../../../../onboarding-business-insight.types';
type RowProps = {
  person: FormattedPerson;
};
const Row = t0 => {
  const $ = _c(34);
  const {
    person: t1
  } = t0;
  const {
    name,
    role,
    submitted,
    associationVerified,
    sources
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "onboardings"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t2);
  const [isNameTruncated, setIsNameTruncated] = useState(false);
  const [isRoleTruncated, setIsRoleTruncated] = useState(false);
  const nameRef = useRef(null);
  const roleRef = useRef(null);
  let t3;
  let t4;
  if ($[1] !== name) {
    t3 = () => {
      const nameElement = nameRef.current;
      if (nameElement && name) {
        setIsNameTruncated(nameElement.offsetWidth < nameElement.scrollWidth);
      }
    };
    t4 = [name];
    $[1] = name;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[4] !== role) {
    t5 = () => {
      const roleElement = roleRef.current;
      if (roleElement && role) {
        setIsRoleTruncated(roleElement.offsetWidth < roleElement.scrollWidth);
      }
    };
    t6 = [role];
    $[4] = role;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  useEffect(t5, t6);
  const t7 = isNameTruncated ? name : undefined;
  let t8;
  if ($[7] !== name || $[8] !== t7) {
    t8 = <p className="truncate text-body-2" ref={nameRef} title={t7}>{name}</p>;
    $[7] = name;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== sources || $[11] !== t) {
    t9 = sources && <Tooltip content={t(_temp, {
      sources
    })}><IcoInfo16 /></Tooltip>;
    $[10] = sources;
    $[11] = t;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t8 || $[14] !== t9) {
    t10 = <div className="flex gap-1 items-center w-full min-w-0 flex-shrink-1">{t8}{t9}</div>;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== submitted || $[17] !== t) {
    t11 = !isNull(submitted) && <Tag>{submitted ? t(_temp2) : t(_temp3)}</Tag>;
    $[16] = submitted;
    $[17] = t;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== associationVerified || $[20] !== t) {
    t12 = !isNull(associationVerified) && <Badge variant={associationVerified ? "success" : "error"}>{associationVerified ? t(_temp4) : t(_temp5)}</Badge>;
    $[19] = associationVerified;
    $[20] = t;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11 || $[23] !== t12) {
    t13 = <div className="flex flex-shrink-0 gap-1 items-center">{t11}{t12}</div>;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t10 || $[26] !== t13) {
    t14 = <td><div className="flex gap-2 items-center">{t10}{t13}</div></td>;
    $[25] = t10;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  const t15 = isRoleTruncated ? role : undefined;
  let t16;
  if ($[28] !== role || $[29] !== t15) {
    t16 = <td><p className="truncate text-body-2" ref={roleRef} title={t15}>{role}</p></td>;
    $[28] = role;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t14 || $[32] !== t16) {
    t17 = <>{t14}{t16}</>;
    $[31] = t14;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  return t17;
};
export default Row;
function _temp($) {
  return $.businessDetails.name.table.source;
}
function _temp2($_0) {
  return $_0.businessShared.tags.submitted;
}
function _temp3($_1) {
  return $_1.businessShared.tags.notSubmitted;
}
function _temp4($_2) {
  return $_2.businessShared.tags.verified;
}
function _temp5($_3) {
  return $_3.businessShared.tags.notVerified;
}